import React, { useState, useEffect } from 'react'

import { Grid } from '@material-ui/core'
import newsStyle from "./newsStyle.jsx"
import withStyles from "@material-ui/core/styles/withStyles"

import iconSocialF from '../../images/svg/icon_share_facebook.svg'
import iconSocialIn from '../../images/svg/icon_share_linkedin.svg'
import iconSocialTw from '../../images/svg/icon_share_twitter.svg'
import iconSocialWh from '../../images/svg/icon_share_whatsapp.svg'
import iconSocialEm from '../../images/svg/icon_share_mail.svg'
import iconSocialTelegram from '../../images/svg/telegram.svg'

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton
} from "react-share"

const SocialShare = ({classes, direction, xs, md, justify, alignItems, classesStyle}) => {

  const [href, setHref] = useState('');

  useEffect(() => {
    setHref(window.location.href);
  }, []);
  
  return (
    <Grid container item xs={xs} md={md} direction={direction} justify={justify} alignItems={alignItems} className={classesStyle}>
      {direction === 'row' &&
      <Grid className={classes.sourceStyle}>
        Condividi su:
      </Grid>}
      <FacebookShareButton
        url={href}>
        <img src={iconSocialF} alt='' className={classes.iconShare}/>
      </FacebookShareButton>
      <TwitterShareButton
        url={href}>
        <img src={iconSocialTw} alt='' className={classes.iconShare}/>
      </TwitterShareButton>
      <LinkedinShareButton
        url={href}>
        <img src={iconSocialIn} alt='' className={classes.iconShare}/>
      </LinkedinShareButton>
      <EmailShareButton
        url={href}>
        <img src={iconSocialEm} alt='' className={classes.iconShare}/>
      </EmailShareButton>  
      <WhatsappShareButton
        url={href}>
        <img src={iconSocialWh} alt='' className={classes.iconShare}/>
      </WhatsappShareButton>
      <TelegramShareButton
        url={href}>
        <img src={iconSocialTelegram} alt='' className={classes.iconShare}/>
      </TelegramShareButton>
    </Grid>
  )
};

export default withStyles(newsStyle)(SocialShare)
